enum EEventName {
  PRODUCT_TRY_AGAIN = 'productTryAgain',
}

export default EEventName;
